
import request from "../utils/request";

export function cmsAddgoods(data) {
    return request({
        url: "/product/cmsAddgoods",
        data: data,
    });
}

export function cmsUpdategoods(data) {
    return request({
        url: "/product/cmsUpdategoods",
        data: data,
    });
}

export function cmsSelgoods(data) {
    return request({
        url: "/product/cmsSelgoods",
        data: data,
    });
}

export function cmsUpdateGoodsNum(data) {
    return request({
        url: "/product/cmsUpdateGoodsNum",
        data: data,
    });
}


